import { render, staticRenderFns } from "./AddToCartButtnInListAdapterForTemplate.vue?vue&type=template&id=a5b5dad8&scoped=true&"
import script from "./AddToCartButtnInListAdapterForTemplate.vue?vue&type=script&lang=ts&"
export * from "./AddToCartButtnInListAdapterForTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b5dad8",
  null
  
)

export default component.exports